import React, { useEffect } from 'react';
import { useModalActions } from 'components/ModalManager/Context';
import { SearchModal } from 'components/UniversalSearch/components/SearchModal/SearchModal';
import { IconSearch } from 'components/Icons';
import { useUniversalSearchStore } from 'components/UniversalSearch/UniversalSearchStore';
import { useField } from 'formik';
import { PlaygroundConfig } from 'modules/Playground/types/playgroundConfig';
import { comboBoxStyled, searchModalStyled, selectedModelStyled } from 'components/UniversalSearch/UniversalSearch.styled';
import { ApiModel } from 'types/swagger/clarifai-api';
const SEARCH_MODAL_ID = 'UNIVERSAL_SEARCH_MODAL';
export const UniversalSearch: React.FC = () => {
  const {
    openModal,
    closeModal
  } = useModalActions();
  const {
    selectedModel
  } = useUniversalSearchStore();
  const onCloseModal = () => {
    closeModal({
      id: SEARCH_MODAL_ID
    });
  };
  const [,, {
    setValue: setSelectedModel
  }] = useField<PlaygroundConfig['model']>('model');
  const onSearchOpen = () => {
    openModal({
      backdropClassName: 'backdropClassName',
      className: searchModalStyled,
      content: <SearchModal onClose={onCloseModal} />,
      contentOuterWrapperClassName: 'contentOuterWrapperClassName',
      contentWrapperClassName: 'contentWrapperClassName',
      hideOnEsc: true,
      id: SEARCH_MODAL_ID,
      makeActions: () => null,
      title: ''
    });
  };
  useEffect(() => {
    setSelectedModel(((selectedModel as unknown) as ApiModel));
    onCloseModal();
  }, [selectedModel]);
  return <div>
      <button type="button" className={comboBoxStyled} onClick={onSearchOpen}>
        <IconSearch size={20} color="#667085" />
        {selectedModel ? <SelectedModelOption model={selectedModel} /> : <span className="placeholder">Search</span>}
      </button>
    </div>;
};
type SelectedModelOptionProps = {
  model: CF.API.Models.Model;
};
const SelectedModelOption: React.FC<SelectedModelOptionProps> = ({
  model
}) => {
  return <div className={selectedModelStyled}>
      <span className="name">{model.display_name || model.name}</span>
      <span className="company">{model.user_id}</span>
    </div>;
};